import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-contest-rules-dialog',
    templateUrl: './contest-rules-dialog.component.html',
    styleUrls: ['./contest-rules-dialog.component.scss']
})
export class ContestRulesDialogComponent implements OnInit {
    public safe_url: SafeResourceUrl = '';

    constructor(
        private sanitizer: DomSanitizer,
        public dialogRef: MatDialogRef<ContestRulesDialogComponent>
    ) { }

    ngOnInit(): void {
        const url = 'https://www.bleachr.co/contest-rules';
        this.safe_url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
